import React from 'react';
import { Domain } from '../../types';

interface Props {
  domains: Domain[];
  value: string;
  onChange: (domain: string | null) => void;
  showAll?: boolean;
  showCounts?: boolean;
}

export const DomainSelector: React.FC<Props> = ({
  domains, value, onChange, showAll = false, showCounts = false
}) => {
  const formatCounts = (domain: Domain) => {
    if (!showCounts) return '';
    const promptsCount = domain.prompts_count ?? 0;
    const schemasCount = domain.schemas_count ?? 0;
    const gtCount = domain.ground_truth_count ?? 0;
    return ` (${promptsCount}P / ${schemasCount}S / ${gtCount}GT)`;
  };

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value || null)}
      className="w-full border rounded px-3 py-2"
    >
      {showAll && <option value="">Tous les domaines</option>}
      {domains.map((domain, index) => (
        <option key={`${domain.name}-${index}`} value={domain.name}>
          {domain.name}{formatCounts(domain)}
        </option>
      ))}
    </select>
  );
};
